import { environment } from '../../environments/environment';

export const baseAPI = `${environment.baseUrl}/api/v1`;

export const orderDetailsAPI = baseAPI + '/order';
export const orderProductsDetailsAPI = orderDetailsAPI + '/product';
export const warningsAPI = orderDetailsAPI + '/warnings';
export const errorsAPI = orderDetailsAPI + '/error';
export const errorsAPISumbmit = orderDetailsAPI + '/submit';

export const tagsAPI = orderDetailsAPI + '/tags';
export const errorCountAPI = errorsAPI + '/count';

export const projectAPI = baseAPI + '/project';
export const projectMaskAPI = projectAPI + '/mask';


export const optionAPI = baseAPI + '/options';
export const optionsAPI = baseAPI + '/options';

export const customerAPI = baseAPI + '/order/customer';


export const publicFileURL = baseAPI + '/public/file'

export const userApiURL = baseAPI + '/users';
export const jiraUserApiURL = baseAPI + '/user/workspace';

export const getJiraTemplates = projectAPI + '/template';
export const budgetAPI = baseAPI + '/order/budget';
export const budgetTagsAPI = budgetAPI + '/tags/autocomplete';


//maintence 
export const maintenceURl = baseAPI + '/maintenance';


